// import React from "react";
// import { Check } from "lucide-react";

// const AccumulationResultModal = ({
//   showResultModal,
//   accumulationResult,
//   onClose,
//   onScanMore,
//   onRedeemGift,
// }) => {
//   if (!showResultModal || !accumulationResult) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
//       <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-y-auto my-4">
//         {/* Modal Body */}
//         <div className="p-4 md:p-6 space-y-6">
//           {/* Summary Stats */}
//           <div className="grid grid-cols-2 gap-3 md:gap-4">
//             <div className="bg-green-50 border border-green-200 rounded-lg p-3 md:p-4">
//               <p className="text-xs md:text-sm text-green-600 font-semibold">
//                 Total Accumulated QR
//               </p>
//               <p className="text-2xl md:text-3xl font-bold text-green-700 mt-1">
//                 {accumulationResult.total_existing_accumulated_count ?? accumulationResult.summary?.total_accumulated_qr_count ?? 0}
//               </p>
//             </div>
//             <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 md:p-4">
//               <p className="text-xs md:text-sm text-purple-600 font-semibold">
//                 Eligible Gifts
//               </p>
//               <p className="text-2xl md:text-3xl font-bold text-purple-700 mt-1">
//                 {accumulationResult.total_eligible_gifts}
//               </p>
//             </div>
//           </div>

//           {/* Available Gifts */}
//           {accumulationResult.all_gifts &&
//             accumulationResult.all_gifts.length > 0 && (
//               <div>
//                 <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
//                   Available Gifts ({accumulationResult.all_gifts.length})
//                 </h3>
//                 <div className="overflow-x-auto">
//                   <table className="w-full border-collapse text-xs md:text-sm">
//                     <thead>
//                       <tr className="bg-gray-200">
//                         <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-left font-semibold">
//                           Gift
//                         </th>
//                         <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
//                           Validated
//                         </th>
//                         <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
//                           Required
//                         </th>
//                         <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
//                           Status
//                         </th>
//                         <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
//                           Action
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {accumulationResult.all_gifts.map((gift, idx) => {
//                         const isEligible =
//                           gift.is_eligible === true &&
//                           gift.qr_count_needed === 0;
//                         return (
//                           <tr
//                             key={idx}
//                             className={`border-b border-gray-300 ${
//                               isEligible ? "bg-green-50" : "bg-yellow-50"
//                             }`}
//                           >
//                             <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3">
//                               <div className="flex items-center gap-2">
//                                 {gift.gift_image && (
//                                   <img
//                                     src={gift.gift_image}
//                                     alt={gift.gift_name}
//                                     className="w-6 h-6 md:w-8 md:h-8 object-cover rounded border border-gray-300 flex-shrink-0"
//                                     onError={(e) => {
//                                       e.target.src =
//                                         'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="32" height="32"%3E%3Crect fill="%23ddd" width="32" height="32"/%3E%3C/svg%3E';
//                                     }}
//                                   />
//                                 )}
//                                 <div className="min-w-0">
//                                   <p className="font-semibold text-gray-900 truncate">
//                                     {gift.gift_name}
//                                   </p>
//                                   <p className="text-xs text-gray-600">
//                                     {gift.scheme}
//                                   </p>
//                                 </div>
//                               </div>
//                             </td>
//                             <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-bold text-blue-600">
//                               {gift.eligible_qr_count ?? 0}
//                             </td>
//                             <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-bold text-red-600">
//                               {gift.qr_count_needed}
//                             </td>
//                             <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center">
//                               <span
//                                 className={`inline-block px-2 md:px-3 py-1 rounded-full text-xs font-semibold ${
//                                   isEligible
//                                     ? "bg-green-200 text-green-800"
//                                     : "bg-yellow-200 text-yellow-800"
//                                 }`}
//                               >
//                                 {isEligible ? "Ready" : "Pending"}
//                               </span>
//                             </td>
//                             <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center">
//                               {isEligible && (
//                                 <button
//                                   onClick={() => onRedeemGift(gift.gift_id)}
//                                   className="bg-green-600 hover:bg-green-700 text-white px-2 md:px-3 py-1 rounded text-xs md:text-sm font-semibold transition"
//                                 >
//                                   Redeem
//                                 </button>
//                               )}
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}
//         </div>

//         {/* Footer */}
//         <div className="sticky bottom-0 bg-gray-100 border-t p-4 md:p-6 flex gap-3">
//           <button
//             onClick={onScanMore}
//             className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 md:py-3 rounded-lg font-semibold transition text-sm md:text-base"
//           >
//             Scan More QR Codes
//           </button>
//           <button
//             onClick={onClose}
//             className="flex-1 bg-gray-400 hover:bg-gray-500 text-white py-2 md:py-3 rounded-lg font-semibold transition text-sm md:text-base"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AccumulationResultModal;

import React from "react";

const AccumulationResultModal = ({
  showResultModal,
  accumulationResult,
  onClose,
  onScanMore,
  onRedeemGift,
  isPromotional,
}) => {
  if (!showResultModal || !accumulationResult) return null;

  // ── PROMOTIONAL UI ─────────────────────────────────────────────────────────
  if (isPromotional) {
    const {
      customer_name,
      total_qr_codes_in_redemptions,
      total_gifts_redeemed,
      total_points_earned,
      total_earned_points_available,
      total_eligible_gifts,
      all_gifts = [],
    } = accumulationResult;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
        <div className="bg-white rounded-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto my-4 shadow-xl">
          <div className="p-5 space-y-5">
            {/* Stats — replaces Total Accumulated QR + Eligible Gifts */}
            <div className="grid grid-cols-4 gap-3">
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-2 text-center">
                <p className="text-xs text-amber-700 font-semibold leading-tight">
                  Total QR Scanned
                </p>
                <p className="text-xl font-bold text-amber-800 mt-1">
                  {total_qr_codes_in_redemptions ?? 0}
                </p>
              </div>
              <div className="bg-purple-50 border border-purple-200 rounded-xl p-2 text-center">
                <p className="text-xs text-purple-700 font-semibold leading-tight">
                  Eligible Gifts
                </p>
                <p className="text-xl font-bold text-purple-800 mt-1">
                  {total_eligible_gifts ?? 0}
                </p>
              </div>
              <div className="bg-green-50 border border-green-200 rounded-xl p-2 text-center">
                <p className="text-xs text-green-700 font-semibold leading-tight">
                  Points Earned
                </p>
                <p className="text-xl font-bold text-green-800 mt-1">
                  {total_points_earned ?? 0}
                </p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-xl p-2 text-center">
                <p className="text-xs text-blue-700 font-semibold leading-tight">
                  Gifts Redeemed
                </p>
                <p className="text-xl font-bold text-blue-800 mt-1">
                  {total_gifts_redeemed ?? 0}
                </p>
              </div>
            </div>

            {/* Available points banner */}
            <div className="flex items-center justify-between bg-amber-100 border border-amber-300 rounded-xl px-4 py-3">
              <span className="text-amber-800 text-sm font-semibold">
                Available Points
              </span>
              <span className="text-amber-900 text-xl font-bold">
                {total_earned_points_available ?? 0}
              </span>
            </div>

            {/* Gifts — same table UI as loyalty */}
            {all_gifts.length > 0 && (
              <div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
                  Available Gifts ({all_gifts.length})
                </h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse text-xs md:text-sm">
                    <thead>
                      <tr className="bg-gray-200">
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-left font-semibold">
                          Gift
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Validated
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Required
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Status
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {all_gifts.map((gift, idx) => {
                        const isEligible =
                          gift.is_eligible === true &&
                          gift.qr_count_needed === 0;
                        return (
                          <tr
                            key={idx}
                            className={`border-b border-gray-300 ${isEligible ? "bg-green-50" : "bg-yellow-50"}`}
                          >
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3">
                              <div className="flex items-center gap-2">
                                {gift.gift_image && (
                                  <img
                                    src={gift.gift_image}
                                    alt={gift.gift_name}
                                    className="w-6 h-6 md:w-8 md:h-8 object-cover rounded border border-gray-300 flex-shrink-0"
                                    onError={(e) => {
                                      e.target.src =
                                        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="32" height="32"%3E%3Crect fill="%23ddd" width="32" height="32"/%3E%3C/svg%3E';
                                    }}
                                  />
                                )}
                                <div className="min-w-0">
                                  <p className="font-semibold text-gray-900 truncate">
                                    {gift.gift_name}
                                  </p>
                                  <p className="text-xs text-gray-600">
                                    {gift.scheme}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-bold text-blue-600">
                              {gift.eligible_qr_count ?? 0}
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-bold text-red-600">
                              {gift.qr_count_needed}
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center">
                              <span
                                className={`inline-block px-2 md:px-3 py-1 rounded-full text-xs font-semibold ${
                                  isEligible
                                    ? "bg-green-200 text-green-800"
                                    : "bg-yellow-200 text-yellow-800"
                                }`}
                              >
                                {isEligible ? "Ready" : "Pending"}
                              </span>
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center">
                              {isEligible && (
                                <button
                                  onClick={() => onRedeemGift(gift.gift_id)}
                                  className="bg-green-600 hover:bg-green-700 text-white px-2 md:px-3 py-1 rounded text-xs md:text-sm font-semibold transition"
                                >
                                  Redeem
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="sticky bottom-0 bg-gray-50 border-t rounded-b-2xl p-4 flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2.5 rounded-xl font-semibold transition text-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── LOYALTY UI (original, unchanged) ──────────────────────────────────────
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-y-auto my-4">
        <div className="p-4 md:p-6 space-y-6">
          {/* Summary Stats — Total Accumulated QR + Eligible Gifts */}
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <div className="bg-green-50 border border-green-200 rounded-lg p-3 md:p-4">
              <p className="text-xs md:text-sm text-green-600 font-semibold">
                Total Accumulated QR
              </p>
              <p className="text-2xl md:text-3xl font-bold text-green-700 mt-1">
                {accumulationResult.total_existing_accumulated_count ??
                  accumulationResult.summary?.total_accumulated_qr_count ??
                  0}
              </p>
            </div>
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 md:p-4">
              <p className="text-xs md:text-sm text-purple-600 font-semibold">
                Eligible Gifts
              </p>
              <p className="text-2xl md:text-3xl font-bold text-purple-700 mt-1">
                {accumulationResult.total_eligible_gifts}
              </p>
            </div>
          </div>

          {/* Available Gifts table */}

          {accumulationResult.eligible_gifts &&
            accumulationResult.eligible_gifts.length > 0 && (
              <div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
                  Available Gifts ({accumulationResult.eligible_gifts.length})
                </h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse text-xs md:text-sm">
                    <thead>
                      <tr className="bg-gray-200">
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-left font-semibold">
                          Gift
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Validated
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Required
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Status
                        </th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-semibold">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {accumulationResult.eligible_gifts.map((gift, idx) => {
                        const isEligible =
                          gift.is_eligible === true &&
                          gift.qr_count_needed === 0;
                        return (
                          <tr
                            key={idx}
                            className={`border-b border-gray-300 ${isEligible ? "bg-green-50" : "bg-yellow-50"}`}
                          >
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3">
                              <div className="flex items-center gap-2">
                                {gift.gift_image && (
                                  <img
                                    src={gift.gift_image}
                                    alt={gift.gift_name}
                                    className="w-6 h-6 md:w-8 md:h-8 object-cover rounded border border-gray-300 flex-shrink-0"
                                    onError={(e) => {
                                      e.target.src =
                                        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="32" height="32"%3E%3Crect fill="%23ddd" width="32" height="32"/%3E%3C/svg%3E';
                                    }}
                                  />
                                )}
                                <div className="min-w-0">
                                  <p className="font-semibold text-gray-900 truncate">
                                    {gift.gift_name}
                                  </p>
                                  <p className="text-xs text-gray-600">
                                    {gift.scheme}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-bold text-blue-600">
                              {gift.eligible_qr_count ?? 0}
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center font-bold text-red-600">
                              {gift.qr_count_needed}
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center">
                              <span
                                className={`inline-block px-2 md:px-3 py-1 rounded-full text-xs font-semibold ${
                                  isEligible
                                    ? "bg-green-200 text-green-800"
                                    : "bg-yellow-200 text-yellow-800"
                                }`}
                              >
                                {isEligible ? "Ready" : "Pending"}
                              </span>
                            </td>
                            <td className="border border-gray-300 px-2 md:px-4 py-2 md:py-3 text-center">
                              {isEligible && (
                                <button
                                  onClick={() => onRedeemGift(gift.gift_id)}
                                  className="bg-green-600 hover:bg-green-700 text-white px-2 md:px-3 py-1 rounded text-xs md:text-sm font-semibold transition"
                                >
                                  Redeem
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gray-100 border-t p-4 md:p-6 flex gap-3">
          <button
            onClick={onScanMore}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 md:py-3 rounded-lg font-semibold transition text-sm md:text-base"
          >
            Scan More QR Codes
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-400 hover:bg-gray-500 text-white py-2 md:py-3 rounded-lg font-semibold transition text-sm md:text-base"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccumulationResultModal;
